
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webcams",
      function () {
        return require("private-next-pages/webcams.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webcams"])
      });
    }
  